import { useCallback } from "react";

import useTranslation from "../../../../../hooks/useTranslation";

export type ShareBadgeKind = "guest" | "invited" | "you";

export type ShareBadge = {
  kind: ShareBadgeKind;
  label: string;
};

export const useShareBadge = () => {
  const { t, m } = useTranslation();
  return useCallback(
    (kind: ShareBadgeKind): ShareBadge => {
      switch (kind) {
        case "guest":
          return { kind, label: t(m.ShareModal.GuestBadge) };
        case "invited":
          return { kind, label: t(m.ShareModal.InvitedBadge) };
        case "you":
          return { kind, label: t(m.ShareModal.YouBadge) };
      }
    },
    [t, m]
  );
};
